const githubreducer=(state,action)=>{
    switch(action.type){
        case 'GET_USERS':
            return{
                ...state,
                users:action.payload,
                loading:false
            }
            case 'SET_LOADING':
                return{
                    ...state,
                    loading:true
                }
                case "REMOVE":
                    return {
                        ...state,
                        users:[],
                        loading:false
                    }
                case "GET_USER":
                    console.log('hello1')
                    return{
                        ...state,
                        user:action.payload,
                        loading:false
                    }
                    case "GET_REPOS":
                        return{
                            ...state,
                            repos:action.payload,
                            loading:false
                        }
        default:
            return state
    }
}

export default githubreducer